<div class="breadcrumbs">
  <div class="d-inline-flex align-items-center">
    <button mat-button
      class="px-1 home-button"
      *ngIf="breadcrumbs.length"
      (click)="goToRoot()">
      <mat-icon>home</mat-icon>
    </button>

    <div class="d-flex align-items-center"
      *ngIf="breadcrumbs.length > 0">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </div>
  </div>

  <div *ngFor="let breadcrumb of breadcrumbs; let index = index; let last = last"
    class="d-inline-flex align-items-center">
    <button mat-button
      [disabled]="last"
      class="px-1"
      (click)="onBreadcrumbClick(breadcrumb, index)">
      {{breadcrumb.label}}{{breadcrumb.name}}
    </button>

    <div class="d-flex align-items-center">
      <mat-icon *ngIf="!last">keyboard_arrow_right</mat-icon>
    </div>
  </div>
</div>